// extracted by mini-css-extract-plugin
export var breadcrumb = "_13-0";
export var breadcrumbArrow = "_13-1";